import { render } from "./MobileDedMoroz.vue?vue&type=template&id=637654f0"
import script from "./MobileDedMoroz.vue?vue&type=script&lang=js"
export * from "./MobileDedMoroz.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__